import { Component , Mixins } from 'vue-property-decorator';
import EdUploadCourseMaterial from '@/content/pages/create-lesson/modals/ed-upload-course-material/ed-upload-course-material.vue';
import EdSectionMaterialTree from '@/courses/components/ed-section-material-tree/ed-section-material-tree.vue';
import { SECTION_TYPES } from '@/content/values/sections';
import {COURSE_EVENTS} from '@/content/values/events';
import { MaterialMixin } from '@/courses/mixins/material.mixin';
import { IparamsComponentSelected } from '@/courses/interfaces/params-component-selected'
import { COMPONENT_TYPE } from '@/courses/values/courses.values'

@Component({
  components: {
    EdSectionMaterialTree
  }
})
export default class EdSectionCourseMaterials extends Mixins(MaterialMixin) {

  /* Data */
  private sectionMaterial: any = {};
  public menuOptions: any[] = [];
  public isLoading: boolean = false;
  public componentKey: number = 0

  /* Computed */

  get sectionId(): string {
    return this.sectionMaterial.sectionId ? this.sectionMaterial.sectionId : 'new';
  }

  /* Methods */
  public goToAddCourseMaterial(optionSelected: any, isRoot?: boolean) {
    isRoot ? this.sectionMaterial = {} : null;
    this.$edEventBus.$emit(COURSE_EVENTS.SECTION_MATERIAL_SELECTED, {
      sectionId: this.sectionId,
      classId: this.classID
    });
    if(optionSelected.type == SECTION_TYPES.SECTION.code) {
      let selectInfo: IparamsComponentSelected = {
      courseId: this.courseID, 
      classId: this.classID,
      componentInfo: {
        name: COMPONENT_TYPE.LESSON_MATERIAL_CREATOR.code,
        edition: false,
        section: this.sectionMaterial,
      }};
      this.goToComponentSelected(selectInfo);
    } else {
      let sectionId: string = this.sectionId == 'new' ? '' : this.sectionId;
      this.$EdModal.createModal(EdUploadCourseMaterial,
      {sectionId , courseId: this.courseID , classId: this.classID,
        contentType: this.contentType});
    }
  }

  private setOptionsMenu() {
    this.menuOptions = [{
      type: SECTION_TYPES.SECTION.code,
      text: this.$i18n.t('common.folder'),
      icon: SECTION_TYPES.SECTION.icon,
      borderBottom:true,
    },
    {
      type: 2,
      text: this.$i18n.t('common.file'),
      borderBottom: false
    }]
  }

  private renderComponent() {
    this.componentKey ++;
  }

  /* Hooks */
  created() {
    this.setOptionsMenu();
    this.$edEventBus.$on(COURSE_EVENTS.ADD_COURSE_MATERIAL, (obj: any) => {
      this.sectionMaterial = obj.section;
      this.goToAddCourseMaterial(obj.option);
    });
    this.$edEventBus.$on(COURSE_EVENTS.REFRESH_COURSE_MATERIALS , this.renderComponent);
  }

  beforeUpdate() {
    this.setOptionsMenu();
  }
}